var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssignPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#270ADC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H28V-2H4V2ZM30 4V28H34V4H30ZM28 30H4V34H28V30ZM2 28V4H-2V28H2ZM4 30C2.89543 30 2 29.1046 2 28H-2C-2 31.3137 0.686292 34 4 34V30ZM30 28C30 29.1046 29.1046 30 28 30V34C31.3137 34 34 31.3137 34 28H30ZM28 2C29.1046 2 30 2.89543 30 4H34C34 0.686292 31.3137 -2 28 -2V2ZM4 -2C0.686292 -2 -2 0.686292 -2 4H2C2 2.89543 2.89543 2 4 2V-2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 14.3125H14.2857V9.25C14.2857 8.62879 14.7975 8.125 15.4286 8.125H16.5714C17.2025 8.125 17.7143 8.62879 17.7143 9.25V14.3125H22.8571C23.4882 14.3125 24 14.8163 24 15.4375V16.5625C24 17.1837 23.4882 17.6875 22.8571 17.6875H17.7143V22.75C17.7143 23.3712 17.2025 23.875 16.5714 23.875H15.4286C14.7975 23.875 14.2857 23.3712 14.2857 22.75V17.6875H9.14286C8.51179 17.6875 8 17.1837 8 16.5625V15.4375C8 14.8163 8.51179 14.3125 9.14286 14.3125Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignPlus);
export default __webpack_public_path__ + "static/media/AssignPlus.068122459a1fd5f6c5363cca4a2c0bd8.svg";
export { ForwardRef as ReactComponent };